var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath158(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1140,
    height: 75,
    viewBox: "0 0 1140 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_158",
    "data-name": "Path 158",
    fill: "#362b15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1139.5 74.5 L 0.5 74.5 L 0.5 19.76922416687012 L 21.42961311340332 0.5 L 1139.5 0.5 L 1139.5 74.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.62451171875 1 L 1 19.98845672607422 L 1 74 L 1139 74 L 1139 1 L 21.62451171875 1 M 21.2342529296875 0 L 1140 0 L 1140 75 L 0 75 L 0 19.54985809326172 L 21.2342529296875 0 Z",
    stroke: "none",
    fill: "#e6c207"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath158);
export default __webpack_public_path__ + "static/media/Path158.e2d7f666555160509ffd3ddd77668e7e.svg";
export { ForwardRef as ReactComponent };